/** Fetch with the session cookie, then ask the browser to save the response. */
export async function downloadCsv(href: string, fallbackFilename: string): Promise<void> {
  const response = await fetch(href, { credentials: 'same-origin' });
  if (!response.ok || !response.headers.get('Content-Type')?.startsWith('text/csv')) {
    throw new Error(response.status === 401 ? 'Your session expired. Sign in and try the export again.' : 'CSV export failed. Please try again.');
  }
  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = /filename="([^"]+)"/.exec(response.headers.get('Content-Disposition') ?? '')?.[1] ?? fallbackFilename;
  document.body.append(anchor);
  anchor.click();
  anchor.remove();
  // Keep the URL alive long enough for browsers to begin reading it.
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
